import { FC } from 'react';
import styled, { DefaultTheme, IntrinsicElementsKeys, StyledComponent } from 'styled-components';

import { SpacingTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

interface IPadded {
	paddingTop?: SpacingTypes | false;
	paddingRight?: SpacingTypes | false;
	paddingBottom?: SpacingTypes | false;
	paddingLeft?: SpacingTypes | false;
	padding?: SpacingTypes | false;
}

const padded = <U>(
	component: StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys
) =>
	styled<StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys>(
		component
	)<IPadded>`
		padding-top: ${({ paddingTop = false, padding = false }) =>
			paddingTop ? theme.spacing[paddingTop] : padding && theme.spacing[padding]};
		padding-right: ${({ paddingRight = false, padding = false }) =>
			paddingRight ? theme.spacing[paddingRight] : padding && theme.spacing[padding]};
		padding-bottom: ${({ paddingBottom = false, padding = false }) =>
			paddingBottom ? theme.spacing[paddingBottom] : padding && theme.spacing[padding]};
		padding-left: ${({ paddingLeft = false, padding = false }) =>
			paddingLeft ? theme.spacing[paddingLeft] : padding && theme.spacing[padding]};
	`;

export default padded;
